import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Cart.css";
import CommonBreadcrumb from "./../common_components/breadcrumb/CommonBreadcrumb";
import ShippingWellness from "./shipping_wellness/ShippingWellness";
import OrderSummary from "./order_summary/OrderSummary";
import { getProduct } from "../../features/admin/product/productdetails/Slice";
import { AllAppSetup } from "../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";

const Cart = () => {
  const dispatch = useDispatch();
  const productsdetails = useSelector((state) => state.product.productdetails);
  const all_app_setup = useSelector((state) => state?.common?.all_app_setup);
  const [qty, setQty] = useState(1);
  const [checkoutData, setCheckoutData] = useState(null);
  const [triggerSubmit, setTriggerSubmit] = useState(null);
  useEffect(() => {
    dispatch(getProduct());
    dispatch(AllAppSetup());
  }, [dispatch]);
  const breadcrumbItems = [
    { label: "Product", link: "/products" },
    { label: "Cart" },
  ];

  return (
    <section className="cart-section">
      <CommonBreadcrumb items={breadcrumbItems} />
      <Container>
        <Row className=" cart-row gx-5 px-3 px-md-5">
          {/* Left Column */}
          <Col xs={12} lg={7}>
            <ShippingWellness
              productsdetails={productsdetails?.products}
              qty={qty}
              setQty={setQty}
              setCheckoutData={setCheckoutData}
              setTriggerSubmit={setTriggerSubmit}
            />
          </Col>

          {/* Right Column */}
          <Col xs={12} lg={5} className=" order-s align-self-start ">
            <OrderSummary
              productsdetails={productsdetails}
              all_app_setup={all_app_setup}
              qty={qty}
              triggerSubmit={triggerSubmit}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Cart;
